import {
    apiRequest,
    excludeAbsenCreate,
    employeeList
} from "../../../../../services/adapters/kepegawaian/excludeAbsenService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", excludeAbsenCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }
}

export default CreateRepository